export enum Surface {
  SURFACE_UNKNOWN = 'SURFACE_UNKNOWN',
  PRODUCT = 'PRODUCT',
  BRAND_PAGE = 'BRAND_PAGE',
  BRAND_PRODUCT_SEARCH_RESULTS = 'BRAND_PRODUCT_SEARCH_RESULTS',
  CATEGORY_PRODUCT_RESULTS = 'CATEGORY_PRODUCT_RESULTS',
  BOARDS = 'BOARDS',
  BUY_AGAIN = 'BUY_AGAIN',
  CHECKOUT_BRAND = 'CHECKOUT_BRAND',
  PRODUCT_BASED_COLLECTION = 'PRODUCT_BASED_COLLECTION',
  BRAND_VIDEO_LIBRARY = 'BRAND_VIDEO_LIBRARY',
  MY_BRANDS = 'MY_BRANDS',
  HOME = 'HOME',
  SEARCH_PRODUCT_RESULTS = 'SEARCH_PRODUCT_RESULTS',
  ORDER_DETAILS = 'ORDER_DETAILS',
  NEW_ARRIVALS = 'NEW_ARRIVALS',
  CART = 'CART',
  SIMILAR_PRODUCTS = 'SIMILAR_PRODUCTS',
  POST_ORDER = 'POST_ORDER',
  DIGEST_PAGE_SCREEN = 'DIGEST_PAGE_SCREEN',
  REORDER_BRANDS_PAGE = 'REORDER_BRANDS_PAGE',
  FOLLOWED_BRANDS_PAGE = 'FOLLOWED_BRANDS_PAGE',
  BRAND_VIDEO_PLAYER = 'BRAND_VIDEO_PLAYER',
  LOGGED_OUT_HOME = 'LOGGED_OUT_HOME',
  DISCOVER_PAGE_SCREEN = 'DISCOVER_PAGE_SCREEN',
  BUNDLES_PAGE = 'BUNDLES_PAGE',
  EXCLUSIVITY = 'EXCLUSIVITY',
  MERCHANDISED_COLLECTIONS = 'MERCHANDISED_COLLECTIONS',
  SEE_MORE_PAGE_SCREEN = 'SEE_MORE_PAGE_SCREEN',
  ASSORTMENT_PAGE = 'ASSORTMENT_PAGE',
  NOW_ON_FAIRE_PAGE = 'NOW_ON_FAIRE_PAGE',
  MARKET_LIST_PAGE = 'MARKET_LIST_PAGE',
  POST_CHECKOUT_PAGE = 'POST_CHECKOUT_PAGE',
  MARKETING_EMAIL = 'MARKETING_EMAIL',
}
